
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import AddAuthorForm from './AddAuthorForm';

interface AddAuthorDialogProps {
  trigger?: React.ReactNode;
}

export default function AddAuthorDialog({ trigger }: AddAuthorDialogProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button>
            <UserPlus className="mr-2 h-4 w-4" />
            Add Author
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add New Author</DialogTitle>
          <DialogDescription>
            Create a new user account with profile and payment information. Choose the role and setup payment preferences.
          </DialogDescription>
        </DialogHeader>
        <AddAuthorForm onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
